import { render, staticRenderFns } from "./deduction_account.vue?vue&type=template&id=a3fc51a2"
import script from "./deduction_account.vue?vue&type=script&lang=js"
export * from "./deduction_account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports